import InputController from './input_controller'

// NOTE: allows deselect selected options
export default class extends InputController {
  clear () {
    this.element.selectedIndex = null
  }
}
